import React, { useEffect } from 'react'
import { baseUrl } from '@fs/zion-config'
import { useTranslation } from 'react-i18next'

import TreeOverviewPageSkeleton from './TreeOverviewPageSkeleton'

/**
 * The Philippines tree overview lives in the asia-pacific app, so it is outside this app's router.
 * Replace the history entry so the back button skips this page instead of bouncing back to it.
 */
export default function PhilippinesRedirect() {
  const [, i18n] = useTranslation()

  useEffect(() => {
    window.location.replace(`${baseUrl}/${i18n.language}/philippines/family-tree/`)
  }, [i18n.language])

  return <TreeOverviewPageSkeleton />
}
